var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuLeftArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_773_5832)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_773_5832)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_773_5832",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_773_5832)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_773_5832",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_773_5832)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3021 2.78491H22.048C22.569 2.78491 23.0001 3.53493 23.0001 4.40393C23.0001 5.31193 22.569 6.06293 22.048 6.06293H11.3021C10.8021 6.06293 10.373 5.31293 10.373 4.40393C10.373 3.53493 10.8041 2.78491 11.3021 2.78491Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0787 10.3809H21.7037C22.0895 10.4261 22.4421 10.6212 22.6853 10.9241C22.9285 11.227 23.0429 11.6134 23.0037 11.9999C23.0433 12.3908 22.93 12.7818 22.6876 13.0911C22.4453 13.4003 22.0927 13.6038 21.7037 13.6589H7.0787C6.69631 13.5953 6.35262 13.3883 6.11758 13.08C5.88253 12.7718 5.77388 12.3855 5.81375 11.9999C5.77424 11.6188 5.88395 11.2373 6.11984 10.9354C6.35572 10.6335 6.69938 10.4347 7.0787 10.3809Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3021 17.9771H22.048C22.569 17.9771 23.0001 18.6881 23.0001 19.5961C23.0001 20.5041 22.569 21.2151 22.048 21.2151H11.3021C10.8021 21.2151 10.373 20.5041 10.373 19.5961C10.373 18.6881 10.8041 17.9771 11.3021 17.9771Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15894 12.8378C2.02791 12.7455 1.92097 12.623 1.84717 12.4808C1.77337 12.3385 1.73486 12.1806 1.73486 12.0203C1.73486 11.86 1.77337 11.7021 1.84717 11.5598C1.92097 11.4175 2.02791 11.2951 2.15894 11.2028L5.77893 8.6508C5.92865 8.5453 6.1045 8.48297 6.28723 8.47056C6.46996 8.45816 6.65258 8.49613 6.81519 8.58042C6.97779 8.66472 7.11411 8.79205 7.20929 8.94853C7.30447 9.105 7.35484 9.28466 7.35492 9.46781V14.5678C7.35484 14.7509 7.30447 14.9305 7.20929 15.087C7.11411 15.2435 6.97779 15.3708 6.81519 15.4551C6.65258 15.5394 6.46996 15.5774 6.28723 15.565C6.1045 15.5526 5.92865 15.4903 5.77893 15.3848L2.15894 12.8378Z"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_773_5832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_773_5832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLeftArrow);
export default __webpack_public_path__ + "static/media/menuLeftArrow.1403a2e7299caebfb010a9d83751b315.svg";
export { ForwardRef as ReactComponent };